import { render, staticRenderFns } from "./page-error.vue?vue&type=template&id=46221814&scoped=true&"
import script from "./page-error.vue?vue&type=script&lang=js&"
export * from "./page-error.vue?vue&type=script&lang=js&"
import style0 from "./page-error.vue?vue&type=style&index=0&id=46221814&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46221814",
  null
  
)

export default component.exports